module.exports = __webpack_public_path__ + "04_long_beige.6cc8e22e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_long_beige.png
// module id = eVAn
// module chunks = 0